import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axiosInstance';
import { useModal } from '../../contexts/ModalContext';

const PaymentVerify = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [credits, setCredits] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get('order_id') || params.get('orderId');

    if (!orderId) {
      setStatus('error');
      setMessage('No order ID provided in URL.');
      return;
    }

    const verifyPayment = async () => {
      try {
        const res = await api.post('/email-verify/verify', { orderId });
        if (!res.data.error) {
          setStatus('success');
          setMessage(res.data.message);
          setCredits(res.data.emailVerifyCredits);
        } else {
          setStatus('error');
          setMessage(res.data.message || 'Verification failed.');
        }
      } catch (err) {
        const msg = err.message === 'Network Error' ? 'No Internet Connection.' : err.message;
        setStatus('error');
        setMessage(msg);
      }
    };

    verifyPayment();
  }, []);

  const handleGoToValidator = () => {
    navigate('/tools/email-verify');
  };

  if (status === 'loading') {
    return (
      <div className="flex items-center justify-center w-full h-[80vh]">
        <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-12 p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mb-12">
      {status === 'success' ? (
        <div className="text-center">
          <svg className="w-12 h-12 mx-auto mb-4 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Payment Successful</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">{message}</p>
          <p className="text-gray-900 dark:text-white mb-6">New Credits: <span className="font-semibold">{credits}</span></p>
        </div>
      ) : (
        <div className="text-center">
          <svg className="w-12 h-12 mx-auto mb-4 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Verification Failed</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-6">{message}</p>
        </div>
      )}

      <div className="text-center">
        <button
          onClick={handleGoToValidator}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
        >
          Go to Email Validator
        </button>
      </div>
    </div>
  );
};

export default PaymentVerify;
